module.exports = __webpack_public_path__ + "img/italy.74eefaee.jpg";